import { Order } from '@@types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { formatOrderReceiptType } from '@shared/uttils/order'

import styles from './styles.module.scss'

type ReceiptsModalProps = {
  order?: Order
}

export default function ReceiptsModal ({
  order
}: ReceiptsModalProps) {
  const { t: to } = useTranslation('order')
  const dataSource = order
  const receipts = dataSource?.receipts ?? []

  return (
    <div className={styles.root}>
      {receipts.map((receipt) => {
        const { label, color } = formatOrderReceiptType(
          receipt?.type,
          to,
        )

        return (
          <a
            key={receipt?.id}
            href={receipt?.receiptPreviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(styles.receipt, styles[`receipt--${color}`])}
          >
            {label}
          </a>
        )
      })}
    </div>
  )
}